<template>
  <section class="section delete-channel-data">
    <form
        class="needs-validation mt-5"
        ref="form"
        novalidate
        @submit.prevent="preventSubmit"
    >
        <b-row>
            <b-col>
                <label class="form-label">Filtra canali per modello: </label>
                <v-select
                    :options="datamodels"
                    :reduce="(ele) => ele.id"
                    :clearable="true"
                    v-model="data.dataModelId"
                    label="name"
                />
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col>
                <label class="form-label">Seleziona canali: </label>
                <multiselect
                    v-model="data.channels"
                    :options="channelsList"
                    :multiple="true"
                    :group-select="false"
                    track-by="code"
                    label="name"
                />
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col class="d-flex align-items-center">
                <span class="form-label mr-2">Dal</span>
                <input
                    type="datetime-local"
                    class="form-control"
                    v-model="data.from"
                    required
                />
            </b-col>
            <b-col class="d-flex align-items-center">
                <span class="form-label mr-2">Al</span>
                <input
                    type="datetime-local"
                    class="form-control"
                    v-model="data.to"
                    required
                />
            </b-col>
        </b-row>
        <b-row class="mt-4">
            <b-col class="d-flex justify-content-end">
                <b-btn type="submit" variant="danger">Elimina</b-btn>
            </b-col>
        </b-row>
    </form>
    <b-modal
        id="summaryModal"
        ref="summaryModal"
        centered
        title="Conferma eliminazione dati"
        header-bg-variant="danger"
        cancel-title="Annulla"
        ok-title="Elimina"
        ok-variant="danger"
        @ok="removeData"
    >
        <p>Si è scelto di eliminare i seguenti dati:</p>

        <p>
            <span v-for="(item, index) in data.channels" :key="index">
                <strong>{{ item.name }}</strong><span v-if="index < data.channels.length - 1">, </span>
            </span>
        </p>

        <p>Dal <strong>{{ formatDate(data.from) }}</strong> alle <strong>{{ formatMinute(data.from) }}</strong> (incluso)</p>
        <p>Al <strong>{{ formatDate(data.to) }}</strong> alle <strong>{{ formatMinute(data.to) }}</strong> (incluso)</p>
        <p>Procedere con l'eliminazione dei dati ?</p>
    </b-modal>
  </section>
</template>

<script>
import api from '@/services/api';
import vSelect from "vue-select";
import Multiselect from "vue-multiselect";
import moment from 'moment';

export default {
  name: "deleteChannelData",
  props: ["datamodels", "channels"],
  components: { vSelect, Multiselect },
  data() {
    return {
        data: {},
    };
  },
  computed: {
    channelsList() {
        let result = [ ...this.channels ];

        if(this.data.dataModelId) {
            result = this.channels.filter((item) => item.data_model_id == this.data.dataModelId);
        }

        return result;
    },
  },
  methods: {
    formatMinute(date) {
        return moment(date, "YYYY-MM-DD hh:mm").format("HH:mm");
    },
    formatDate(date) {
        return moment(date, "YYYY-MM-DD hh:mm").format("DD MMM YYYY");
    },
    async removeData() {
        this.$store.commit("loading");
        try {
            let data = { ...this.data };

            const channels = data.channels;
            
            data.channel_codes = [];

            channels.forEach(item => {
                data.channel_codes.push(item.code);
            })

            const response = await api().post("/data/delete", data);

            if(response.data.code == 1) {
                if(response.data.data > 0) {
                    this.$notify({
                        type: "success",
                        text: "Eliminati " + response.data.data + " record",
                        title: "Successo",
                    });
                } else {
                    this.$notify({
                        type: "success",
                        text: "Dati non presenti, nessun record eliminato",
                        title: "Successo",
                    });
                }
            }
            
            this.$refs.summaryModal.hide();
            this.$store.commit("stopLoading");
        } catch(e) {
            this.$notify({
                type: "error",
                text: e.message,
                title: 'Errore',
            });
            this.$store.commit("stopLoading");
        }
    },
    openSummaryModal() {
        this.$refs.summaryModal.show();
    },
    preventSubmit() {
        if(! this.$refs.form.checkValidity()) {
            this.$refs.form.classList.add("was-validated");
            return;
        }

        if(moment(this.data.from).diff(moment(this.data.to)) >= 0) {
            this.$notify({
                type: "error",
                text: "La data di inizio deve essere precedente a quella di fine",
                title: 'Errore'
            });
            return;
        }
        
        if(! this.data.channels || this.data.channels.length < 1) {
            this.$notify({
                type: "error",
                text: "Selezionare almeno un canale",
                title: 'Errore'
            });
            return;
        }

        this.openSummaryModal();
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>


// WEBPACK FOOTER //
// src/components/Admin/Sites/DeleteChannelData.vue